import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}groups/`;

export function getGroups(searchCriteria) { 
    var url = baseUrl + "search";

    return fetch(url, { method: "POST", body: JSON.stringify(searchCriteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getUserGroups() {
    var url = baseUrl + "getusergroups";

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupsForUser(userId) {
    var url = `${baseUrl}getgroupsforuser/${userId}`;
    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroup(id) {
    var url = baseUrl + id;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupNameAndAvatar(id) {
    var url = `${baseUrl}getnameandavatar/${id}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupByFriendlyUrl(friendlyUrl) {
    var url = `${baseUrl}getgroupbyfriendlyurl/${friendlyUrl}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function saveGroup(group) {
    return fetch(baseUrl + (group.id || ""),
        {
            method: group.id ? "PUT" : "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(group),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function uploadAvatar(avatar) {
    return fetch(baseUrl + "uploadavatar", { method: "PUT", body: JSON.stringify(avatar), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function uploadBanner(banner) {
    return fetch(baseUrl + "uploadbanner", { method: "PUT", body: JSON.stringify(banner), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function isGroupNameUnique(id, name, friendlyUrl) {

    return new Promise(function (resolve, reject) {
        var details = { groupId: id, name: name, nameUnique: false, friendlyUrl: friendlyUrl, friendlyUrlUnique: false };
        var url = `${baseUrl}isgroupnameunique/`;
        return fetch(url, { method: "POST", body: JSON.stringify(details), headers: { "content-type": "application/json" }, credentials: "include" })
            .then(response => {
                if (response.ok) {
                    resolve(response.json());
                }
            })
            .catch(error => {
                reject(error)
            });
    });

}

export function addUserToGroup(userId, groupId) {
    var url = baseUrl + "addusertogroup";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function removeUserFromGroup(userId, groupId) {
    var url = baseUrl + "removeuserfromgroup";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function makeUserGroupAdmin(userId, groupId) {
    var url = baseUrl + "makeusergroupadmin";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function revokeUserGroupAdmin(userId, groupId) {
    var url = baseUrl + "revokeusergroupadmin";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function requestGroupMembership(userId, groupId) {
    var url = baseUrl + "requestgroupmembership";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function confirmUserGroupMembership(userId, groupId) {
    var url = baseUrl + "confirmgroupmembership";
    var groupUser = { userId: userId, groupId: groupId }

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function rejectUserGroupMembership(userId, groupId, reason) {
    var url = baseUrl + "rejectgroupmembership";
    var groupUser = { userId: userId, groupId: groupId, reason: reason}

    return fetch(url, { method: "PUT", body: JSON.stringify(groupUser), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function searchForUsersAdd(searchString, groupId) {
    var url = baseUrl + "searchforuserstoadd";
    var search = { searchString: searchString, groupId: groupId }

    return fetch(url, { method: "POST", body: JSON.stringify(search), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function archiveGroup(id) {
    var url = `${baseUrl}archivegroup/${id}`;

    return fetch(url, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function reactivateGroup(id) {
    var url = `${baseUrl}reactivategroup/${id}`;

    return fetch(url, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function searchGroups(searchCriteria) {
    var url = baseUrl + "search";

    return fetch(url, { method: "POST", body: JSON.stringify(searchCriteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function listMostActiveGroups() {
    var url = baseUrl + "listmostactive";

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function sendGroupInvitations(groupId, emails) {
    var url = baseUrl + "inviteuserstogroup";
    var request = {
        groupId: groupId,
        emails: emails
    }

    return fetch(url, { method: "POST", body: JSON.stringify(request), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupInvitation(code) {
    var url = `${baseUrl}getgroupinvitation/${code}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function archiveGroupInvitation(code) {
    var url = `${baseUrl}archivegroupinvitation/${code}`;

    return fetch(url, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}



// WEBPACK FOOTER //
// ./src/api/groupsApi.js